import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-dark px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md rounded-3xl bg-white p-10">
        <div className="font-display text-2xl font-black tracking-tighter text-ink">
          ADOPT<span className="text-crimson">-A-</span>PHONE
        </div>
        <h1 className="mt-6 font-display text-2xl font-bold text-ink">Admin sign in</h1>
        <p className="mt-1 text-sm text-muted-foreground">Manage your iPhone catalog.</p>

        {error && <div data-testid="login-error" className="mt-5 rounded-xl bg-red-50 px-4 py-3 text-sm font-medium text-crimson">{error}</div>}

        <div className="mt-6">
          <label className="text-sm font-bold text-ink">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="mt-2 w-full rounded-xl border border-line px-4 py-3 outline-none focus:border-crimson" />
        </div>
        <div className="mt-4">
          <label className="text-sm font-bold text-ink">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="mt-2 w-full rounded-xl border border-line px-4 py-3 outline-none focus:border-crimson" />
        </div>
        <button disabled={loading} type="submit" data-testid="login-submit" className="mt-6 w-full rounded-full bg-crimson py-3.5 font-bold text-white transition-colors hover:bg-crimson-hover disabled:opacity-60">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
